var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticStyle:{"height":"auto","width":"100vw","margin-right":"5px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }